import {StyleSheet} from 'react-native';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    button: {
      flex: 1,
    },
    marginLeft16: {
      marginLeft: 16,
    },
    topMargin0: {
      marginTop: 0,
    },
    cityContainer: {
      flexDirection: 'row',
      marginTop: 24,
    },
    noteInput: {
      minHeight: 80,
      paddingVertical: 0,
    },
    noteContainer: {
      padding: 16,
    },
  });

export default makeStyles;
